<div matDialogTitle>Inga meddelanden</div>
<mat-dialog-content>
  <p>Du har inga meddelanden</p>
</mat-dialog-content>
<mat-dialog-actions>
  <button mat-raised-button mat-dialog-close>OK</button>
</mat-dialog-actions>